module.exports = __webpack_public_path__ + "img/auth-success.012787dd.svg";